import { useEffect } from "react";

/**
 * A hook the disables scrolling on the page
 *
 * @param isLocked Whether the viewport should be locked
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;
    const originalStyle = window.getComputedStyle(document.body).overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isLocked]);
};
